// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media screen and (max-width: 900px) {\n.filter-representation[data-v-d59ce480] {\n    width: 70vw;\n    margin-right: 20px;\n}\n}\n@media screen and (min-width: 900px) {\n.filter-representation[data-v-d59ce480] {\n    width: 35vw;\n    margin-right: 20px;\n}\n}\n\n", ""]);
// Exports
module.exports = exports;
